module.exports = __webpack_public_path__ + "images/my-integral-icon-rule.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/my-integral-icon-rule.png
// module id = 886
// module chunks = 130